<template>
  <a href="http://fleetware.hu" class="fleetware-logo"><img src="../../../public/img/fleetware_logo_3.png"></a>
</template>
<script>
import { Routes } from '@/order-wizard/utils/Routes.js'

export default {
  name: 'FleetwareLogo',
  data () {
    return {
      Routes
    }
  }
}
</script>
<style lang="scss" scoped>
@media(max-width: 768px) {
  .fleetware-logo img{
    margin-right: 0px;
  }
}
</style>
